module.exports = __webpack_public_path__ + "img/comparison-brand-category.8c98ac79.png";